import { UserOptionLabel } from "@/components";
import { RemoveFormItem } from "@/components/RemoveFormItem";
import { DEFAULT_DEBOUNCE_TIME } from "@/config";
import { selectFilterHelper } from "@/helpers";
import { optionFieldType, optionType } from "@/propTypes";
import { useSuggestUsersQuery } from "@/services";
import { Form, Select, Space, Spin } from "antd";
import debounce from "lodash.debounce";
import { arrayOf, func } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNewFormFieldContext } from "../NewFormFieldProvider";

const { Option } = Select;

export const OptionUserValue = ({
  field,
  remove,
  availableDependantValues,
}) => {
  const intl = useIntl();
  const { formRef } = useNewFormFieldContext();

  const [value, setValue] = useState();
  const [query, setQuery] = useState();

  const { data: userSuggestions, isFetching } = useSuggestUsersQuery(
    { query },
    { skip: !query }
  );

  const onSearch = debounce((value) => {
    setQuery(value);
  }, DEFAULT_DEBOUNCE_TIME);

  const handleChange = (value) => {
    setValue(value);
  };
  const handleSelect = (_, option) => {
    const options = formRef.current.getFieldValue("options");
    options[field.key].fallback = option.label;
    formRef.current.setFieldsValue({ options });
  };

  return (
    <Space key={field.key} style={{ display: "flex", alignItems: "center" }}>
      <Form.Item
        isListField={field.isListField}
        name={[field.name, "UserId"]}
        key={[field.fieldKey, "UserId"]}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.optionUserRequired",
            }),
          },
        ]}
      >
        <Select
          data-test-id={`option-user-value${value}`}
          showSearch
          defaultActiveFirstOption={false}
          placeholder={intl.formatMessage({
            id: "newFormField.optionUserPlaceholder",
          })}
          filterOption={false}
          allowClear
          onSearch={onSearch}
          optionLabelProp="label"
          value={value}
          onChange={handleChange}
          onSelect={handleSelect}
          notFoundContent={isFetching ? <Spin size="small" /> : null}
          style={{ minWidth: "200px" }}
        >
          {userSuggestions?.map(
            ({
              document: { id, displayName, department, email, jobTitle },
            }) => (
              <Option key={id} label={displayName}>
                <UserOptionLabel
                  displayName={displayName}
                  department={department}
                  email={email}
                  jobTitle={jobTitle}
                />
              </Option>
            )
          )}
        </Select>
      </Form.Item>
      <Form.Item isListField={field.isListField} name={[field.name, "dependsOnPropertyValues"]}>
        <Select
          mode="multiple"
          style={{ maxWidth: 500, minWidth: 300 }}
          allowClear
          placeholder={intl.formatMessage({
            id: "newFormField.dependentValuesPlaceholder",
          })}
          filterOption={selectFilterHelper}
        >
          {availableDependantValues.map(({ value, text }) => (
            <Select.Option value={value} key={value}>
              {text}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <RemoveFormItem
        parentComponent="option-user-value"
        uniqueKey={value}
        remove={() => remove(field.name)}
      />
    </Space>
  );
};

OptionUserValue.propTypes = {
  remove: func,
  field: optionFieldType.isRequired,
  availableDependantValues: arrayOf(optionType).isRequired,
};
